"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DRGUserService = function () {
  function DRGUserService($http, $rootScope) {
    _classCallCheck(this, DRGUserService);

    if ($rootScope.globals) $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
    this.$http = $http;
  }

  _createClass(DRGUserService, [{
    key: "getUsers",
    value: function getUsers() {
      return this.$http.get("" + WEBSERVICEURL + "/dataagility/api/service.episodeauditlookupvalues/PCCLModifiedUser");
    }
  }]);

  return DRGUserService;
}();

var ChangespercoderController = function ChangespercoderController($http, $scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService) {
  _classCallCheck(this, ChangespercoderController);

  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
  this.datatableApi;
  this.user = User.getUser();
  this.name = "Changes Per Coder";
  this.episodeValue = "";
  this.specialtyString = "";
  this.separationString = "";
  this.TEC = "TODO";
  this.TEA = "TODO";
  this.currentCoderName = "";
  this.locale = "en-au";

  this.url = WEBSERVICEURL + "/dataagility/api/service.changespercoder/query?";
  this.initUrl = this.url + "startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L") + "&coder=" + this.currentCoderName + "&status=&specialty=";

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
    $scope.vm.functionSettings = response.functionSettings;

    // All Private Clients should be active, All Public should be inactive
    if ($scope.vm.episodeValue === '$') {
      console.log('WIES vars set to private');
      $scope.vm.wiesDefault = "0.00";
      $scope.vm.wiesParseAmount = 2;
    } else {
      console.log('WIES vars set to public');
      $scope.vm.wiesDefault = "0.0000";
      $scope.vm.wiesParseAmount = 4;
    }

    if ($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive) {
      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
        return x.mData === "drgVersion";
      });
      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
      $scope.vm.dtColumns[indexOfDRGVersionColumn].visible;
    }

    Constants.campusData().then(function successCallback(response) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        var campusOptions = [];
        if (typeof $scope.vm.user.campus === "string") {
          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
        } else {
          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
        }
        $scope.vm.campusOptions = campusOptions;
        $scope.vm.campus.selectedCampus = campusOptions;
      } else {
        $scope.vm.campusOptions = response;
      }
      filterCampus($scope.vm.campusOptions);
    });
  });

  new DRGUserService($http, $scope).getUsers().then(function successCallback(response) {
    angular.forEach(response.data, function (data, key) {
      $scope.vm.coderOptions.push(data);

      var indexOfSplitOfCommaSeparated = data.indexOf(", ");
      // If calhn then in 'Surname, FirstName' format
      if (indexOfSplitOfCommaSeparated > -1) {
        var splitNames = data.split(", ");
        $scope.vm.currentCoderName = splitNames[1] + " " + splitNames[0];
      } else {
        $scope.vm.currentCoderName = data;
      }

      // If the current coder in this iteration is the currently logged in user then set Coder Filter to them
      if ($scope.vm.currentCoderName === $scope.vm.user.name) {
        $scope.vm.coder.selectedCoder = data;
      }
    });

    $scope.vm.coderOptions.sort();

    if ($scope.vm.coder.selectedCoder === undefined) {
      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0].value;
    }
  }, function errorCallback(response) {
    if (response.status === 401) {
      window.location.replace(window.location.origin + "/login?logout=true");
    }
  });

  materialButtons.render();

  materialButtons.processing();

  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);

    // setup search filters
    search();

    // tell DataTables we're using Aussie-formatted dates for ordering
    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");

    // set the table to a fixed height, so it never collapsed up and down
    $("#auditTable").closest(".dataTables_scrollBody").height(300);
  };

  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
    headers: {
      Authorization: "Bearer " + $rootScope.globals.currentUser.token
    },
    url: $scope.vm.initUrl,
    type: "GET",
    error: function error(xhr, _error, thrown) {
      if (thrown == "Unauthorized") {
        //window.location.replace(window.location.origin + '/login');
        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
      }
    }
  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
    // Update column headers if data returned
    setDtHeaders($("#auditTable").DataTable());
  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("scrollX", "auto").withOption("aaSorting", [[2, "desc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    extend: "print",
    text: ""
  }, {
    extend: "csvHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    extend: "excelHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    text: "",
    action: function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]).withColumnFilter({
    aoColumns: [{ type: "number" }, { type: "date-range" }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "select" }, { type: "select" }, { type: "number" }, {
      type: "text",
      bRegex: true,
      bSmart: true
    }, { type: "number" }]
  });

  function yesNo(data) {
    return data === true ? "Yes" : "No";
  }

  this.dtColumns = [
  // DTColumnBuilder.newColumn("PCCLModifiedUser")
  //   .withTitle("Original Coder")
  //   .withClass("mdl-data-table__cell--non-numeric")
  //   .notVisible(),
  DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditCriteria").withTitle("Audit Criteria").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drgVersion").withTitle("DRG<br>Version").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").notVisible(), DTColumnBuilder.newColumn("drg").withTitle("Original<br>DRG").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("finalDRG").withTitle("Final<br>DRG").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    var displayCell = full.drg !== full.finalDRG && data ? '<span class="bold">' + data + "</span>" : data ? data : '';
    return displayCell;
  }), DTColumnBuilder.newColumn("wies").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
  }), DTColumnBuilder.newColumn("finalWIES").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
  }), DTColumnBuilder.newColumn("totalWiesChange").withTitle("Loading...").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    var toFloat = parseFloat(data).toFixed($scope.vm.wiesParseAmount),
        displayCell = toFloat !== $scope.vm.wiesDefault && !isNaN(toFloat) ? '<span class="bold">' + toFloat + "</span>" : $scope.vm.wiesDefault;
    return displayCell;
  }), DTColumnBuilder.newColumn("auditFinalisedDateTime").withTitle("Date Finalised").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? moment(data).format('DD/MM/YYYY HH:mm') : '';
  }), DTColumnBuilder.newColumn("codesAdded").withTitle("Codes<br>Added").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("codesRemoved").withTitle("Codes<br>Deleted").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("queryGenerated").withTitle("Query<br>Generated").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return yesNo(data);
  }), DTColumnBuilder.newColumn("episodeChange").withTitle("Episode<br>Change").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return yesNo(data);
  }), DTColumnBuilder.newColumn("incompleteDocumentation").withTitle("Inc.<br>Docs").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return yesNo(data);
  }), DTColumnBuilder.newColumn("status").withTitle("Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").notVisible(), DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric")];

  // Search filters
  this.campus = {
    selectedCampus: []
  };
  this.campusOptions = [];

  this.specialty = {
    selectedSpecialty: []
  };
  this.specialtyOptions = {};

  this.status = {
    selectedStatus: []
  };
  this.statusOptions = {};

  this.coderOptions = [];
  this.coder = {
    selectedCoder: null
  };

  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
    $scope.vm.specialtyOptions = response.specialties;
    filterSpecialty($scope.vm.specialtyOptions);
  });

  this.startDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
    }
  };
  this.endDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "days"),
      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
    }
  };

  // callbacks for lx-selects and lx-date-picker
  datePicker.autoClose($scope);
  this.coderCallback = coderCallback;
  this.coderDisabled = coderDisabled;

  // Respond to user selection
  // re-draw table on datepicker close
  $scope.$on("lx-date-picker__close-start", function (e, id) {
    $scope.vm.coderCallback();
  });

  function setDtHeaders(table) {
    $(table.column(getIndexOfColumn('dischargeDate')).header()).html($scope.vm.separationString + " Date");
    $(table.column(getIndexOfColumn('speciality')).header()).html($scope.vm.specialtyString);
    $(table.column(getIndexOfColumn('wies')).header()).html("Original " + $scope.vm.episodeValue);
    $(table.column(getIndexOfColumn('finalWIES')).header()).html("Final " + $scope.vm.episodeValue);
    $(table.column(getIndexOfColumn('totalWiesChange')).header()).html($scope.vm.episodeValue + " Change");
  }

  function getIndexOfColumn(columnName) {
    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === columnName;
    });
    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
  }

  function coderCallback(_newValue, _oldValue) {
    if ($scope.vm.coder.selectedCoder === null && $scope.vm.coderOptions[0]) {
      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0].value;
    }
    var campus = "";
    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
        campus = $scope.vm.user.campus;
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
    } else {
      campus = $scope.vm.campus.selectedCampus;
    }
    var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&coder=" + $scope.vm.coder.selectedCoder + "&status=" + checkParam($scope.vm.status.selectedStatus) + "&campus=" + checkParam(campus) + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty);
    if ($scope.vm.datatableApi) {
      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
    }
  }

  function checkParam(param) {
    if (param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  function coderDisabled() {
    return $scope.vm.user.role !== "Administrator" && $scope.vm.user.role !== "Reporter";
  }

  function filterCoder(swap) {
    if (coderDisabled()) {
      $scope.vm.coder.selectedCoder = $scope.vm.currentCoderName;
      $scope.vm.coderCallback();
    }
  }

  function filterCampus(modifier) {
    $scope.vm.campus.selectedCampus = [];
    if (modifier === "add") {
      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
    }
  }

  function filterSpecialty(swap) {
    $scope.vm.specialty.selectedSpecialty = [];
    if (swap === "add") {
      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
    }
  }

  function filterStatus(STATUSES) {
    // status
    $scope.vm.statusOptions = CONST.STATUS;
    $scope.vm.status.selectedStatus = [];

    angular.forEach(STATUSES, function (value, key) {
      $scope.vm.status.selectedStatus.push($scope.vm.statusOptions[value]);
    });

    $scope.vm.coderCallback();
  }

  function setDefaultDate() {
    $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, "months").startOf("month");
    $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, "months").startOf("month").format("L");

    $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, "days");
    $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, "days").format("L");
  }

  function search() {
    // delete any global searches previously applied
    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();

    var auditTable = $scope.vm.datatableApi;
    auditTable.search("").draw();

    filterCampus("minus");
    filterSpecialty("minus");
    filterStatus();
    filterCoder();

    // re-draw tabele on datepicker close
    $scope.$on("lx-date-picker__close-start", function (e, id) {
      if ($scope.vm.coder.selectedCoder === null) {
        $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0].value;
      }
      var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&coder=" + $scope.vm.coder.selectedCoder + "";
      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
    });
  }

  // bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }

  // bind filter swap
  this.filterSwap = filterSwap;

  function filterSwap(thisFilter, thisModifier) {
    switch (thisFilter) {
      case "campus":
        if (thisModifier === "add") {
          filterCampus("add");
        } else {
          filterCampus("minus");
        }

        break;

      case "specialty":
        if (thisModifier === "add") {
          filterSpecialty("add");
        } else {
          filterSpecialty("minus");
        }

        break;

      case "status":
        if (thisModifier === "add") {
          filterStatus([0, 1, 2, 3, 4]);
        } else {
          filterStatus([]);
        }

        break;

      default:
        break;
    }
  }
};

exports.default = ChangespercoderController;


// WEBPACK FOOTER //
// ./client/app/common/reports/changespercoder/changespercoder.controller.js